/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Audience } from './Audience';
import {
    AudienceFromJSON,
    AudienceFromJSONTyped,
    AudienceToJSON,
} from './Audience';

/**
 * 
 * @export
 * @interface CreateAudience201Response
 */
export interface CreateAudience201Response {
    /**
     * 
     * @type {Audience}
     * @memberof CreateAudience201Response
     */
    data?: Audience;
}

/**
 * Check if a given object implements the CreateAudience201Response interface.
 */
export function instanceOfCreateAudience201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateAudience201ResponseFromJSON(json: any): CreateAudience201Response {
    return CreateAudience201ResponseFromJSONTyped(json, false);
}

export function CreateAudience201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAudience201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : AudienceFromJSON(json['data']),
    };
}

export function CreateAudience201ResponseToJSON(value?: CreateAudience201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': AudienceToJSON(value.data),
    };
}

